document.addEventListener('DOMContentLoaded', (event) => {
  if (window.innerWidth <= 425) {
    
    
  }

  
  if (window.innerWidth <= 798) {
    
    $('#shopify-section-1489125942243 .js-featured-promotions').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: true,
      arrows: false
    });
    $('#shopify-section-1597256095717 .js-featured-promotions').slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: true,
      arrows: false
    });
    
    
    
    
  const mobileNavMenu = ((clog) => {
      	clog('listening menu mobile')
        
    	const [...menuContainer] = document.querySelectorAll('.mobile-menu');
      	const [...titleNavs]     = document.querySelectorAll('.menuSelector');
      	const [...closeBtns]     = document.querySelectorAll('.closeMenu');
      
      	// Listeners
      titleNavs.forEach( title => {
        title.addEventListener('click', (evt) => {
        	let divId = evt.target.parentElement.getAttribute('data-id')
            let menuDiv = document.getElementById(divId)
            
            if ( menuDiv.classList.contains('kick-to-right') ) {
            	menuDiv.classList.remove('kick-to-right')
            }
          
            menuDiv.classList.add('enter-from-right')
        })
      })
      
      closeBtns.forEach( cross => {
        cross.addEventListener('click', (evt) => {
        	let divId = evt.target.getAttribute('data-id')
            let menuDiv = document.getElementById(divId)
            
            if ( menuDiv.classList.contains('enter-from-right') ) {
            	menuDiv.classList.remove('enter-from-right')
            }
          
            menuDiv.classList.add('kick-to-right')
        })
      })
      	
    })(console.log)
  }
  
  
  
  
  
  
  const watchCountyMegaMenuFunction = (() => {
      console.log('watching county menu')
      const divMegaMenu2        = document.querySelector('[data-dropdown-rel="county"]');
      let enabled = false;
  
      divMegaMenu2.addEventListener('mouseenter', () => {
        console.log('atroden')
        if ( !enabled ){
          let [...countyElements] = document.querySelectorAll('.megaMenuCounty');
          let [...mainImg]        = document.querySelectorAll('.imageMegaMenu2');

          console.log(countyElements, mainImg);

          countyElements.forEach( (elem,index) => {

            if ( index >= 32 && index <= 64 ){

              elem.addEventListener('mouseenter', (evt) => {
                evt.preventDefault();
                evt.stopPropagation();

                let imgSrc = evt.target.children[0].src

                mainImg[1].src = imgSrc
                console.log(evt.target.children[0].src)
              })
            }

          })
          
          enabled = true;

        }
        
      })

  })()
  
  
  const contactUsPage = ((clog) => {
    if ( window.location.href.includes('/pages/contact-us') ) {
        clog('Contact Us page')
        
        // Variables
        const [...tabButtons] = document.querySelectorAll('.map-information__tabs-buttons > a');
        const [...tabDivs]    = document.querySelectorAll('.sixteen.columns.map-information > div');
      	
      	// Listeners
        tabButtons.forEach( tabBtn => {
            tabBtn.addEventListener('click', (evt) => {
                evt.preventDefault()
                evt.stopPropagation()
                clog(evt.target)
                clog( document.getElementById(evt.target.href.split('#')[1]) )
                
                removeActiveClass( tabButtons )
                removeActiveClass( tabDivs )
				hideDivs()
                
                let tabId = evt.target.href.split('#')[1]

                evt.target.classList.add('active')
                document.getElementById(tabId).classList.add('active')
                document.getElementById(tabId).style.display = 'block'
            })
        })


        // Functions
        function removeActiveClass( elems ) {
          elems.forEach( elem => {
            if ( elem.classList.contains('active') ) {
              elem.classList.remove('active')
            }
          })
        }
      
        function hideDivs() {
          tabDivs.forEach( elem => {
            elem.style.display = 'none'
          })
        }
    }
  })(console.log)
  
  
  const supportPage = ((clog) => {
    if ( window.location.href.includes('/pages/support') ) {
  		clog('Support Page')
    	
        const [...tabLinks]     = document.querySelectorAll('.tabLink');
      	const [...tabContent]   = document.querySelectorAll('.tabContent');
      		
      tabLinks.forEach( tab => {
        tab.addEventListener('click', (evt) => {
          	evt.preventDefault()
        	removeActiveClassLinks( tabLinks, 'tabLink' )
            removeActiveClassLinks( tabContent, 'tabContent' )
            
            let divId = evt.target.href.split('#')[1]
            
            document.getElementById(divId).style.display = 'block'
            document.getElementById(divId).classList.add('active')
            evt.target.parentElement.classList.add('active')
        })
      })
      	
      	// Functions
        function removeActiveClassLinks( elems, type ) {
          if ( type === 'tabLink' ) {
            elems.forEach( elem => {
              if ( elem.parentElement.classList.contains('active') ) {
                elem.parentElement.classList.remove('active')
              }
            })
          }
          
          if ( type === 'tabContent' ) {
          	elems.forEach( elem => {
              if ( elem.classList.contains('active') ) {
                elem.classList.remove('active')
              }
              elem.style.display = 'none'
            })
          }
          
          
        }
    }
  })(console.log)

});
